(function(){
  const announcementHeight = document.querySelector(".announcement-bar").offsetHeight;
  document.documentElement.style.setProperty("--announcement-height", "".concat(announcementHeight, "px"));
})();

$(document).ready(function(){    
  $(document).on("click", ".more-faq", function(){
    if ($(this).text() == "See more Faq")
         $(this).text("See less Faq")
      else
         $(this).text("See more Faq");
     $(".faq-more").toggleClass('faq-hide');
  });

  // $(document).on("click", ".cdk_wishlist__block .cdk-wishlist", function(){
  //   if ($(this).text() == "save for later")
  //        $(this).text("remove")
  //   else
  //        $(this).text("save for later");
  // });

  
  
});

//   $(document).on("click", ".cdk-quick-view", function(){
//     var proTitle = $('.quick-product .cdk_wishlist__block .cdk-wishlist').attr('product-title');
//     var cd_myWhishlist = clean_value( localStorage.getItem("cd_myWhishlist") ); 
//     console.log(proTitle +'wishlist:'+ cd_myWhishlist);

// var cd_myWhishlist = localStorage.getItem("cd_myWhishlist");
//   var valueArrayWhishlist = cd_myWhishlist.split(',');
//   valueArrayWhishlist.splice(valueArrayWhishlist.indexOf(productTitle),1);
//   var valueArrayWhishlistToString = valueArrayWhishlist.toString();  
//   localStorage.setItem("cd_myWhishlist",valueArrayWhishlistToString);
    
//     if (cd_myWhishlist == proTitle) {
//         $('.quick-product .cdk_wishlist__block .cdk-wishlist').text("remove");
//       } else {
//         $('.quick-product .cdk_wishlist__block .cdk-wishlist').text("save for later");
//     }
//   });

  $(window).on("resize",function(){console.log("resize"),setTimeout(function(){$(".recommended-products__slider-wrapper").slick("resize")},500)});
  $(window).on("orientationchange",function(){
    $('.recommended-products__slider-wrapper').slick('resize');
  });

//wishlist
// function clean_value(data){
// data = $.trim(data);
// return data;
// }
// function update_wishlist_product_icon(){
// var fillColorCode = '#FFF';
// var cd_myWhishlist = clean_value( localStorage.getItem("cd_myWhishlist") ); 
// if(cd_myWhishlist != null && cd_myWhishlist != ''){
//   var valueArrayWhishlist = cd_myWhishlist.split(','); 
//   console.log('valueArrayWhishlist :: '+valueArrayWhishlist);
//   $('.cdk_wishlist__block .cdk-wishlist').each(function(){
//     var productTitle = clean_value( $(this).attr('product-title') );
//     if(productTitle != '' && $.inArray(productTitle, valueArrayWhishlist ) > -1){
//       $(this).toggleClass('productAdded');
//       // $(this).children('svg path').attr('fill',fillColorCode);
//       if ($(this).hasClass('productAdded')) {
//         $(this).text("remove");
//       } else {
//         $(this).text("save for later");
//       }
//     }
    
//   })
// }
// }
// function loading_dots(){
// var dotNum = parseInt($('#wishlist__product_container .dots__loading').attr('data-dot-num')); 
// if(typeof dotNum == 'undefined'){
//   var setDots = '...' ; var dotNum = '3';
// }
// else if(dotNum == 3){
//   var setDots = '.' ; var dotNum = '1';
// }
// else if(dotNum == 1){
//   var setDots = '..' ; var dotNum = '2';
// }
// else if(dotNum == 2){
//   var setDots = '...' ; var dotNum = '3';
// }
// else{
//   var setDots = '...' ; var dotNum = '3';
// }

// $('#wishlist__product_container .dots__loading').html(setDots);
// $('#wishlist__product_container .dots__loading').attr('data-dot-num',dotNum);
// }
// function loading_whishlist_product(productTitle,mywishlistLoader){
// var url = '/search?q='+productTitle ; var fillColorCode = '#1F1F1F';
// $.ajax({
//   url: url,
//   type: "get",
//   dataType: "html",
//   success: function(htmlData) {
//     clearInterval(mywishlistLoader);
//     if( $('#wishlist__product_container .dots__loading').length > 0 ){ $('#wishlist__product_container').html('');  }
//     var wishlistProductHtml = $(htmlData).find('#root .search__results .grid-item').html();
//     $('#wishlist__product_container').append(wishlistProductHtml);
//     // $('#wishlist__product_container').find('.cdk-icons.cdk-wishlist').children('svg').attr('fill',fillColorCode);
//   },
//   error: function(jqXHR, textStatus, errorThrown) {
//     if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
//   }
// });
// }

// function update_wishlist_Count(){
// var cd_myWhishlistCount = clean_value( localStorage.getItem("cd_myWhishlist") );
// if(cd_myWhishlistCount != ''){
//   var valueArrayWhishlistCount = cd_myWhishlistCount.split(','); 
// }else{
//   var valueArrayWhishlistCount = '';
//   localStorage.removeItem("cd_myWhishlist"); 
// }
// console.log('cd_myWhishlistCount::'+cd_myWhishlistCount);
// console.log('valueArrayWhishlist::'+valueArrayWhishlistCount.length);
//  $('.cdk_wishlist_count').text(valueArrayWhishlistCount.length);
//   if(valueArrayWhishlistCount.length == '0'){
//     var noWishlistProductAlertHtml = '<div class="emptywishlist"><p class="no__Wishlist_Product__exists">This list is empty.</p><a href="/collections/all" class="btn btn--medium btn--full btn--primary cdk-btn">Shop now</a></div>';
//     $('#wishlist__product_container').addClass('emptyWishlist');
//     $('#wishlist__product_container').html(noWishlistProductAlertHtml);
//   }
  
// }

// function update_wishlist_page(){
// var mywishlistLoader = setInterval(loading_dots, 500); // clearInterval(mywishlistLoader);

// var cd_myWhishlist = clean_value( localStorage.getItem("cd_myWhishlist") );
// if(cd_myWhishlist != null && cd_myWhishlist != ''){
//   var valueArrayWhishlist = cd_myWhishlist.split(','); 
//   for(var st = 0;st < valueArrayWhishlist.length;st++){
//     var productTitle = clean_value(valueArrayWhishlist[st]);
//     if(productTitle != ''){ loading_whishlist_product(productTitle,mywishlistLoader); }
//   }
// }
// else
// {
//   var noWishlistProductAlertHtml = '<div class="emptywishlist"><p class="no__Wishlist_Product__exists">This list is empty.</p><a href="/collections/all" class="btn btn--medium btn--full btn--primary cdk-btn">Shop now</a></div>';
//   $('#wishlist__product_container').addClass('emptyWishlist');
//   $('#wishlist__product_container').html(noWishlistProductAlertHtml);
// }
// }

// update_wishlist_Count();   

// $(document).on("click", "#wishlist__product_container .cdk_wishlist__block .cdk-wishlist", function(){
//   var productTitle = clean_value( $(this).attr('product-title') );
//   var cd_myWhishlist = localStorage.getItem("cd_myWhishlist");
//   var valueArrayWhishlist = cd_myWhishlist.split(',');
//   valueArrayWhishlist.splice(valueArrayWhishlist.indexOf(productTitle),1);
//   var valueArrayWhishlistToString = valueArrayWhishlist.toString();  
//   localStorage.setItem("cd_myWhishlist",valueArrayWhishlistToString);
//   $(this).parents('.product-item').remove();
//   update_wishlist_Count();
//   console.log('valueArrayWhishlist::'+valueArrayWhishlist);
// });
// $(document).on("click", ".cdk_wishlist__block .cdk-wishlist", function(){
//   if( $("#wishlist__product_container").length > 0 ){ return false; }
//   var productTitle = clean_value( $(this).attr('product-title') ); var cd_myWhishlist = localStorage.getItem("cd_myWhishlist");
//   var fillColorCode = '#1F1F1F';
//   if(cd_myWhishlist == null){
//     if(productTitle != ''){ 
//       localStorage.setItem("cd_myWhishlist",productTitle); 
//       $(this).toggleClass('productAdded');
//       $(this).children('svg').attr('fill',fillColorCode);
//     }
//   }
//   else{
//     var valueArrayWhishlist = cd_myWhishlist.split(',');
//     if(productTitle != ''){
//       var newList = cd_myWhishlist+productTitle;
//       if($.inArray(productTitle, valueArrayWhishlist ) == -1){
//         if(valueArrayWhishlist.length > 0){
//           var newList = cd_myWhishlist+','+productTitle;
//         }
//         localStorage.setItem("cd_myWhishlist",newList);
//         $(this).toggleClass('productAdded');
//         $(this).children('svg').attr('fill',fillColorCode);
//       }
//       else{
//         valueArrayWhishlist.splice(valueArrayWhishlist.indexOf(productTitle),1);
//         var valueArrayWhishlistToString = valueArrayWhishlist.toString();  
//         localStorage.setItem("cd_myWhishlist",valueArrayWhishlistToString);
//         $(this).removeClass('productAdded');
//         $(this).children('svg').attr('fill','');
//       }
//     }
//   } 
//    update_wishlist_Count();
// });
// update_wishlist_product_icon();
// if( $('#wishlist__product_container').length > 0 ){ 
//   update_wishlist_page();
// }
// end wishlist

//Ajax Cart Count Function Start
function cartCount(){ $.getJSON('/cart.js', function(cart) { $("[data-js-cart-count]").html(cart.item_count); });}
//Ajax Cart Count Function End

function updateMiniCart()
{
  $.ajax({
    type: "GET", 
    url: "/",
    dataType: 'html',

    success: function(data) 
    {
     // $('body').append('<div id="fakedata">'+data+'</div>');
      var miniCartHead = $(data).contents().find('.quick-cart__container').html(); 
      //console.log('miniCartHead::'+miniCartHead); 
      $('.quick-cart__container').html(miniCartHead);  
      $('.quick-cart.animation--quick-cart').addClass('animation--quick-cart-revealed');
      $('.quick-cart__wrapper').addClass('active');
      $('body').css({'padding-right':'15px', 'overflow': 'hidden'});
    }
  })
}


jQuery(document).ready(function($) {
  $(document).on('click', '.thumbnail-overlay .add_to_cart', function() {
    var productId = $(this).siblings('select').val();
    var buttonElement = $(this);
    var buttonText = $(this).html();
    var addingText = "Adding ...";
    var soldoutText = "Sold out";
    
    $(this).html(addingText);
    $.ajax({
      url: "/cart/add",
      dataType: "json",
      type: "post",
      data: {
        id: productId
      },
      success: function () {
        cartCount();
        updateMiniCart();
        buttonElement.html(buttonText);
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: productId,
            quantity: 1
          }
        }));
      },
      error: function () {
        buttonElement.html(buttonText);
      }
    });
    
  });
  
  $(document).on('change', '.thumbnail-overlay select', function() {
    var availablity = $(this).find(':selected').data('sold');
    var soldoutText = "Sold out";
    var normalText = "Add to cart";
    if (availablity == false) {
      $(this).siblings('.add_to_cart').html(soldoutText);
      $(this).siblings('.add_to_cart').attr('disabled', true);
    }
    else {
      $(this).siblings('.add_to_cart').html(normalText);
      $(this).siblings('.add_to_cart').attr('disabled', false);
    }
  });
  
  $('.article-product-block').each(function(){
    var handleThis = $(this);
    var productHandle = handleThis.data('handle');
    var productHtml = '';
    var productPrice = 0;
    var selectHtml = '';
    jQuery.getJSON('/products/' + productHandle + '.js', function(product) {
      console.log(product);
      productPrice = parseFloat(product.price) / 100.0;
      productHtml = '<a href="' + product.url + '">' + '<img src="' + product.featured_image + '"></a>' + 
        	 	 	'<a class="product-item__text" href="' + product.url + '">' + '<span class="title product-item__product-title">' + product.title + '</span></a>' + 
        			'<span class="price">£' + productPrice.toFixed(2).toString() + '</span>';
      if (product.available) {
        selectHtml = '<div class="thumbnail-overlay"><select id="product-select-' + product.id + '">';
        var variantIndex;
        for (variantIndex in product.variants) {
          var variant = product.variants[variantIndex];
          var variantPrice = parseFloat(variant.price) / 100.0;
          if (variant.available) {
            selectHtml += '<option value="' + variant.id + '" data-price="£' + variantPrice.toFixed(2).toString() + '" data-sku="' + variant.sku + '">' + variant.title + '</option>';
          }
        }
        selectHtml += '</select>';
        productHtml += selectHtml + '<button class="add_to_cart qa btn btn--primary" type="submit" name="add">Add to cart</button></div>';
      }
      else {
        productHtml += '<button class="sold_out qa" type="submit" name="add">Sold out</button>';
      }
      handleThis.append(productHtml);
      $('.article-product-block select').trigger('change');
    });
  });
  $(document).on('change', '.article-product-block select', function() {
    $(this).parents('.article-product-block').find('.price').text($(this).find(':selected').data('price'));
  });
});


// 02-05-2023 


function ajaxAddToCartProduct(currentThis,dynamicData) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
      $('.loading-overlay__spinner').addClass('hidden');
      $('.button-shop--now').removeClass('loading');
      $('.product-item .cdk_quickView').attr('data-btn', 'quickview');
     // $('.product-item .cdk_quickView').find('.btn_text').text('Choose Option');
      $('.product-item .quick-view-wrapper').hide();
      updateMiniCart(currentThis); 
      cartCount();
    },
    error: function(jqXHR, textStatus, errorThrown) {
      $('.loading-overlay__spinner').addClass('hidden');
      $('.button-shop--now').removeClass('loading');
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

function ajaxAddToCartProductPage(currentThis,dynamicData) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
     
      currentThis.removeClass('loading');
      updateMiniCart(currentThis); 
      cartCount();
    },
    error: function(jqXHR, textStatus, errorThrown) {
      currentThis.removeClass('loading');
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}


$(document).ready(function() {  
  

   // Quick view
  
  $(document).mouseup(function(e){
      var container = $(".product-item");
   
      // If the target of the click isn't the container
      if(!container.is(e.target) && container.has(e.target).length === 0){
        $('.product-item .cdk_quickView').attr('data-btn', 'quickview');
        //$('.product-item .cdk_quickView').find('.btn_text').text('Choose Option');
        $('.product-item .quick-view-wrapper').hide();  
        //$(".cdk_quickView.cdk_plus_icon").removeClass('transform');
      }
    });
  
  $(document).on('click','.button-shop--now[data-btn="quickview"]:not([data-btn="soldout"])',function(){   
    //$('.product-item .cdk_quickView').attr('data-btn', 'quickview');
    $(this).parents('.product-item').siblings().find('.cdk_quickView').attr('data-btn', 'quickview');
    $(this).parents('.product-item').find('.cdk_quickView').attr('data-btn', 'quickview');
    //$('.product-item .cdk_quickView').find('.btn_text').text('Choose Option');
    $('.product-item .quick-view-wrapper').hide();  
    $(this).parents('.product-item').find('.quick-view-wrapper').show();
    $(this).parents('.product-item').find('.swatches-option.selected').trigger('click');
    var thisParentId = $(this).attr('data-id');
    $('.quick-view-wrapper[data-id="'+thisParentId+'"] select.product_card-form__master-select').change();
  });

  $(document).on('click','.button-shop--now[data-btn="addToCart"]',function(){
    //$(".cdk_quickView.cdk_plus_icon").removeClass('transform');   
      var currentThis = $(this);var updateItems = [];var variantId =  $(this).attr('data-variant');var quantity = 1;   var selling_plan = $(this).attr('data-sellingplan'); 
      //console.log('selling_plan::'+selling_plan);
    if(selling_plan == '' || selling_plan == 'undefined'){
      updateItems.push({ "id": variantId, "quantity": quantity });
    }else{
      updateItems.push({ "id": variantId, "quantity": quantity, "selling_plan": selling_plan });
    } 
     ajaxAddToCartProduct(currentThis,updateItems);currentThis.addClass('loading');currentThis.find('.loading-overlay__spinner').removeClass('hidden');
    
  });
 
  
  $(document).on('click','.cdk--custom_subscription_options .subscription_pan_item',function(){  
     var thisParentId = $(this).parents('.quick-view-wrapper').attr('data-id'); 
    $('.quick-view-wrapper[data-id="'+thisParentId+'"] .cdk--custom_subscription_options .subscription_pan_item').removeClass('active');
    $(this).addClass('active');
    $('.quick-view-wrapper[data-id="'+thisParentId+'"] select.product_card-form__master-select').change();
  });

  
   $(document).on('click','.quick-view-wrapper .swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.swatches-block').find('select').val(OptionName).change();
    //console.log("OptionName::"+OptionName);
  })
  
  $(document).on('change','.quick-view-wrapper .swatches-block select', function () {
    var FinalValue = '';
    var thisParentId = $(this).parents('.quick-view-wrapper').attr('data-id');
    $(this).parents('.quick-view-wrapper').find(' .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
      //console.log('selectVal::'+selectVal);
    });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
      //console.log('newstr::'+newstr);
 
    
    var optionName_Selector = $(this).parents('.quick-view-wrapper').find('select.product_card-form__master-select option[check-data-sku="'+newstr+'"]')
     var optionName_val = optionName_Selector.val();

    // var Selected_price = optionName_Selector.attr('data-price');
    // var Selected_availability = optionName_Selector.attr('data-varaint-availability');
    // var Selected_variant = optionName_Selector.attr('value');
    // console.log('Selected_price::'+Selected_price);
    // console.log('Selected_availability::'+Selected_availability);
    // console.log('Selected_variant::'+Selected_variant);
    
    //console.log('optionName_val::'+optionName_val);
     $(this).parents('.quick-view-wrapper').find(' select.product_card-form__master-select').val(optionName_val).change();
 
    })


    $(document).on('change','.quick-view-wrapper select.product_card-form__master-select', function () {
      var thisMainVal = $(this).val(); 
      var thisParentId = $(this).parents('.quick-view-wrapper').attr('data-id');
      //console.log('thisMainVal::'+thisMainVal);
      // console.log('thisParentId::'+thisParentId);
      var thiSubType = $('.quick-view-wrapper[data-id="'+thisParentId+'"] .cdk--custom_subscription_options .subscription_pan_item.active').attr('data-type');
      //console.log('thiSubType::'+thiSubType);
      var ThisSellingPlan = $('.quick-view-wrapper[data-id="'+thisParentId+'"] .cdk_prod_selling_palns').val();
      //console.log('ThisSellingPlan::'+ThisSellingPlan);
      var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
      //console.log('ThisProdAvail::'+ThisProdAvail);
      var ThisProdNP =$(this).find('option[value="'+thisMainVal+'"]').attr('data-price');
      //console.log('ThisProdNP::'+ThisProdNP);
      var ThisProdSP =$(this).find('option[value="'+thisMainVal+'"]').attr('data-price-sp');
      //console.log('ThisProdSP::'+ThisProdSP);
      
     if(thiSubType == 'subscription'){
       $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-sellingplan',ThisSellingPlan);
       $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.price-item').text(ThisProdSP);
       $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_subscription').show();
     }else{
      $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-sellingplan',''); 
       $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.price-item').text(ThisProdNP);
       $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_subscription').hide();
     }
      $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-variant', thisMainVal);
      if (ThisProdAvail == 'true'){
        $('.cdk_quickView[data-id="'+thisParentId+'"]').find('.btn_text').text('Add To Cart');
        console.log('.cdk_quickView[data-id="'+thisParentId+'"]');
        console.log('.cdk_quickView[data-id="'+thisParentId+'"]');
         $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-btn', 'addToCart');
      }else{
        $('.cdk_quickView[data-id="'+thisParentId+'"]').find('.btn_text').text('Sold Out');
         $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-btn', 'soldout');
      } 
      
    })

  $(document).on("click",".recharge-subscription-widget .rc-widget .rc-template__button-group  .rc-radio" ,function() { 
   setTimeout(function () {
     $('variant-radios .product-form__input input:checked+label').click();
   },500)
  });
  
  
  $(document).on("click","variant-radios .product-form__input label" ,function() { 
    var thisValue = $(this).prev('input').attr('value');
    // console.log('thisValue::'+thisValue);
    var thisValueid = $('#custom_cdk_subscription_values option[data-variant-main="'+thisValue+'"]').val();
    // console.log('thisValueid::'+thisValueid);
    $('#custom_cdk_subscription_values').val(thisValueid).change();

  });
  
    $(document).on('change', '#custom_cdk_subscription_values', function(){  
    var thisvalId = $(this).val();
    var regular_price = $(this).find('option[value="'+thisvalId+'"]').attr('data-var-price');
    var subscription_price = $(this).find('option[value="'+thisvalId+'"]').attr('data-price-sp');
    // console.log('thisvalId::'+thisvalId);
    // console.log('regular_price::'+regular_price);
    // console.log('subscription_price::'+subscription_price);
    var checkLength = $('.recharge-subscription-widget .rc-widget .rc-template__button-group .rc-radio--active.subscription-radio').length;
    //console.log('checkLength::'+checkLength);
    if(checkLength == 1){
      $('.cdk_product_price .price-item--regular').text(subscription_price);  
      
    }else{
      $('.cdk_product_price .price-item--regular').text(regular_price);  
    }
  });

  $(document).on("click",".cart_related_products > h3 .closeBtn" ,function() { 
    $(this).parents('.cart_related_products').hide();
  });
  
                  
});

// $(document).ready(function(){
//   $(".cdk_quickView.cdk_plus_icon").click(function(){    
//     $(this).parents('.product-item').siblings().find('.quick-view-wrapper').hide();
//     $(this).parents('.product-item').siblings().find('.cdk_quickView.cdk_plus_icon').removeClass('transform');
//     $(this).parents('.product-card-wrapper').find('.quick-view-wrapper').toggle();
//     $(this).toggleClass('transform');
//   });
// });
$(document).ready(function(){ 
  $(document).on("click",".product-swatches .cdk_close_icon" ,function() {
       $('.product-item .quick-view-wrapper').hide(); 
       $(this).parents('.product-item').find('.cdk_quickView').attr('data-btn', 'quickview');
        $(this).parents('.product-item').find('.btn_text').text('Add +');
  });
});

$(document).ready(function(){
  $(document).on("click",".quick-cart__close-icon, .quick-cart__wrapper .quick-cart__overlay" ,function(event) {
    event.preventDefault();
    $("body").removeAttr("style");
  });

  // $(document).on("click",".acc-head" ,function() {
  //   // event.preventDefault();
  //   $(this).toggleClass("active");
  // });
  
});


/*            11-05-2023               */
//accordion start
  $(document).ready(function() {
    $('.acc-head').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        } else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideDown();
            $(this).toggleClass('active');
        }
    });
});
//accordion ends
 

function ajaxAddToCart(dynamicData,currentThis) {   
 $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){ 
         $.ajax({
            url: "/cart/add.js",
            type: "POST",
            data: {items:dynamicData},
            dataType: "json",
            success: function(data){ 
              $('#cdk-BuyProductGroup').text('PROCEED TO CHECKOUT');
              window.location.href = "/checkout";
            },
            error: function(jqXHR, textStatus, errorThrown) {
              $('#cdk-BuyProductGroup').text('PROCEED TO CHECKOUT');
              if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
              if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
            }
          });
      },
      dataType: 'json'
  });
 
}
 


$(document).on('click', '.add-to-cart, button.js-qty__adjust', function(){
  setTimeout(function(){
    UpdateProgressBar();
  },800)  
  setTimeout(function(){
    UpdateProgressBar();
  },1500)  
})



// Bundle Code Start


function priceUpdate(){
    var FThisOutputPrice = 0;
     var currencySign = $('#lp_bundle_page').attr('data-currency');
    $('.lp_bundle_row').find('.lp_bundle_product_item.selected').each(function () {
      var FThisPrice = parseFloat($(this).attr('data-price'));
      var FThisQty = parseFloat($(this).attr('data-quantity'));
      var FThisOutput = FThisPrice * FThisQty ;   
      FThisOutputPrice+= FThisOutput;
      console.log('FThisOutputPrice::'+FThisOutputPrice);
    }) 
  var finalRegPrice = FThisOutputPrice.toFixed(2);
  $('.lp-bundle_checkout_inner .bundle_price_block .bundle_regular_price').text(currencySign+' '+finalRegPrice);
}


  $(document).on('click','.lp_bundle_product_item:not(.open)', function(){
    var thisOptions = $(this).attr('data-options'); 
    var ItemCount = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    console.log(ItemCount);
    if ( ItemCount <= 2 ) {
    
      $(this).addClass('open');
      if(thisOptions == 'true'){
        $(this).find('.bundle_variant_selector').show();
      }
        
      }  else {
        $("#dialog").show();
      }
   
  })


  $(document).on('click','.bundle_variant_selector .swatches-option',function(event){
    event.preventDefault();
    $(this).siblings().removeClass('selected ');
    $(this).addClass('selected');
    var dValue = $(this).attr('data-value');
    var dFinalValue = $(this).parents('.bundle_variant_selector').find('.product_card-varient-select option[check-data-sku="'+dValue+'"]').val();
    var dFinalAvail = $(this).parents('.bundle_variant_selector').find('.product_card-varient-select option[check-data-sku="'+dValue+'"]').attr('data-varaint-availability');
    var dFinalprice = $(this).parents('.bundle_variant_selector').find('.product_card-varient-select option[check-data-sku="'+dValue+'"]').attr('data-price');
    var dFinalMain = $(this).parents('.bundle_variant_selector').find('.product_card-varient-select option[check-data-sku="'+dValue+'"]').attr('data-main-price');
    var dFinalsize =$(this).parents('.bundle_variant_selector').find('.product_card-varient-select option[check-data-sku="'+dValue+'"]').attr('check-data-sku');
    $(this).parents('.bundle_variant_selector').find('.product_card-varient-select').val(dFinalValue).change();
    $(this).parents('.lp_bundle_detail').find('.item_Price_price').text(dFinalprice);
    $(this).parents('.lp_bundle_product_item').attr('data-price', dFinalMain);
    $(this).parents('.lp_bundle_product_item').attr('data-value', dFinalsize);
    if(dFinalAvail == 'true'){
    $(this).parents('.lp_bundle_detail').find('.bty_btn_flex').addClass(' selected ');  
    $(this).parents('.lp_bundle_detail').find('.bty_btn_text').hide(); 
    $(this).parents('.bundle_variant_selector').hide();
    $(this).parents('.lp_bundle_detail').find('.bty_btn_flex .input_btn.plus').click();      
    }else{
    $(this).parents('.lp_bundle_detail').find('.bty_btn_flex').removeClass(' selected ');
    $(this).parents('.lp_bundle_detail').find('.bty_btn_text').show(); 
    }
    // console.log('dFinalsize::'+dFinalsize);
  });

// popop close start

  $(document).on('click','.lp_bundle_product_item.open .bundle_addbtn',function(){
    $(this).parents('.lp_bundle_product_item').removeClass('open selected');
    $(this).parents('.lp_bundle_product_item').find('.bundle_variant_selector').hide();
    $(this).parents('.lp_bundle_product_item').find('.bundle_variant_selector .swatches-block .swatches-option').removeClass('selected');
    $(this).parents('.lp_bundle_detail').find('.bty_btn_text').hide(); 
    $(this).parents('.lp_bundle_detail').find('.bty_btn_flex').removeClass(' selected '); 

  var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
  var thisVal = parseInt(thisVal);

    $(this).parents('.lp_bundle_product_item').find('input').val('0');
    $(this).parents('.lp_bundle_product_item').attr('data-quantity', '0');
  
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id');    
    //console.log('thisId::' +thisId + 'thisVal::' + thisVal);
    $('.bundle-item-wrapper .selected-items li[datavalue="'+thisId+'"]').remove();
    
    priceUpdate();

  })
// popop close end

  $(document).on('change','.product_card-varient-select',function(event){  
    var ThisFInalVal = $(this).val(); 
    //console.log('ThisFInalVal::'+ThisFInalVal);
    $(this).parents('.lp_bundle_product_item').attr('var-id', ThisFInalVal);
  });


  $(document).on('click','.lp_bundle_product_item .lp_bundle_detail .input_btn.plus', function(){
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id'); 
    var thisImage = $(this).parents('.lp_bundle_product_item').find('.bundle_prod_image').attr('src');
    var thistitle = $(this).parents('.lp_bundle_product_item').find('.lp_bundle_prod_title').text();
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal);
    var thisIncrement = parseInt(thisVal + 1); 
    var sFinalValue = $(this).parents('.lp_bundle_product_item').attr('data-value'); 
    var ItemCount = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    console.log(ItemCount);
    if ( ItemCount <= 2 ) {
    $('.bundle-item-wrapper .selected-items').append(' <li datavalue="'+thisId+'" data-list-id="'+thisId+'-'+thisIncrement+'"><div class="product"><img src="'+thisImage+'"></div><div class="title">'+thistitle+'</div><span class="size">'+sFinalValue+'</span><span data-id="'+thisId+'" class="remove-item">x</span></li> ');
    $(this).next('.bty_btn_flex').addClass('selected');
    $(this).parents('.lp_bundle_product_item').find('input').val(thisVal + 1);
    $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal + 1);
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    var LengthOfItemInc = LengthOfItem +1 ; 
    priceUpdate();
    if(LengthOfItem >= 1){
      $('.lp-bundle_checkout .bundle-atc').addClass('active'); 
    }
    // if(LengthOfItem > 5){
    //  $('.bundle-item-wrapper .items').append('<li data-index="'+LengthOfItemInc+'"> <div class="product" bis_skin_checked="1">+</div></li>'); 
    // } 
        
      }  else {
        $("#dialog").show();
      }
  })

  $(document).on('click','.lp_bundle_product_item .lp_bundle_detail .input_btn.minus', function(){
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id'); 
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal); 
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    var LengthOfItemInc = LengthOfItem +1 ; 
    
    if (!isNaN(thisVal) && thisVal > 1) {
      $('.bundle-item-wrapper .selected-items li[data-list-id="'+thisId+'-'+thisVal+'"]').remove();      
      $(this).parents('.lp_bundle_product_item').find('input').val(thisVal - 1);
      $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal - 1);      
      if(LengthOfItem > 5){
       $('.bundle-item-wrapper .items li[data-index="'+LengthOfItemInc+'"]').remove();
      }      
    }else if(!isNaN(thisVal) && thisVal == 1){
      $('.bundle-item-wrapper .selected-items li[data-list-id="'+thisId+'-'+thisVal+'"]').remove();      
      $(this).parents('.lp_bundle_product_item').find('input').val(thisVal - 1);
      $(this).parents('.lp_bundle_product_item').removeClass('open');
      $(this).parents('.bty_btn_flex').removeClass('selected');
      $(this).parents('.lp_bundle_product_item').find('.bundle_variant_selector').hide();
      $(this).parents('.lp_bundle_product_item').removeClass('selected').attr('data-quantity', 0);
      if(LengthOfItem > 5){
       $('.bundle-item-wrapper .items li[data-index="'+LengthOfItemInc+'"]').remove();
      }
    }
    priceUpdate();  
    $(this).parents('.lp_bundle_product_item').find('.bundle_variant_selector .swatches-block .swatches-option').removeClass('selected');
  })

  $(document).on('click','.bundle_checkout_products .bundle-item-wrapper ul.selected-items li .remove-item', function(){
    var thisId = $(this).attr('data-id');
    $('.lp_bundle_container .lp_bundle_row .lp_bundle_product_item[var-id="'+thisId+'"]').find('.input_btn.minus').click();
  })
   
  $(document).on('click' ,'#cdk-BuyProductGroup',function(){
    $(this).text('Please wait...')
    var items = []; 
    $('.lp_bundle_container .lp_bundle_row').find('.lp_bundle_product_item.selected').each(function(){
      var variantId = $(this).attr('var-id'), quantity = $(this).attr('data-quantity');
      if(quantity > 0){items.push({ quantity: quantity,  id: variantId});}
    })
   ajaxAddToCart(items);
  });
  
  $('.closePop').click(function(){
    $('#dialog').hide();
  });
  
// Bundle code end



// Product page swatches options Strat
 
    $(document).on('click','.cdk_product_swatches .product-swatches-block .product_swatches-item-box .product-swatches-option', function () {
      var OptionName = $(this).attr('data-value');
      $('.product-swatches-option').removeClass('selected');
      $(this).addClass('selected');
      $(this).parents('.product-swatches-block').find('select').val(OptionName).change();
      $(this).parents('.product-swatches-block').find('.product_name_indicator').text(OptionName);
      //console.log("OptionName::"+OptionName);
    })

  $(document).on('change','.cdk_product_swatches .product-swatches-block select', function () {
    var FinalValue = '';
    $('.cdk_product_swatches .product-swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
      //console.log('selectVal::'+selectVal);
    });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
      //console.log('newstr::'+newstr);
    var optionName_Selector = $('.cdk_product_swatches select.product_page-form__master-select option[check-data-sku="'+newstr+'"]')
     var optionName_val = optionName_Selector.val();
    $('.cdk_product_swatches select.product_page-form__master-select').val(optionName_val).change();

      // Dispatch variant change event
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variantTitle: newstr
        }
      }));
    })


    $(document).on('change','.cdk_product_swatches select.product_page-form__master-select', function () {
      var thisMainVal = $(this).val(); 
      //console.log('thisMainVal::'+thisMainVal);
      var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
      //console.log('ThisProdAvail::'+ThisProdAvail);
      var ThisProdNP =$(this).find('option[value="'+thisMainVal+'"]').attr('data-price');
      //console.log('ThisProdNP::'+ThisProdNP);
      var ThisProdCP =$(this).find('option[value="'+thisMainVal+'"]').attr('data-compare');
      //console.log('ThisProdCP::'+ThisProdCP);
      var ThisProdSKU =$(this).find('option[value="'+thisMainVal+'"]').attr('data-sku');
      //console.log('ThisProdSKU::'+ThisProdSKU);
      var prodLink = $(location).attr("href");
      var cleanUrl = prodLink.split('?')[0];
      //console.log('cleanUrl::'+cleanUrl);
      var newUrl = cleanUrl+'?variant='+thisMainVal;
      //console.log('newUrl::'+newUrl);

      var jsonText = $('script[data-product-inventory-json]').html(); 
      var jsonData = JSON.parse(jsonText); 
      var inventory = jsonData.inventory; 
      var value = inventory[thisMainVal];  

      if(ThisProdSKU != ''){
        $('.product__vendor_and_sku .product__sku').text('SKU '+ThisProdSKU);
      }else{
        $('.product__vendor_and_sku .product__sku').text('');
      }
      
      $('.inventory-counter .inventory-counter__message').text(value.inventory_message);
      if(value.inventory_quantity == 0){
        $('.inventory-counter').attr('data-stock-category', 'empty');
      }else if(value.inventory_quantity < 41){
        $('.inventory-counter').attr('data-stock-category', 'low');
      }else{
        $('.inventory-counter').attr('data-stock-category', 'sufficient');
      }
      if(value.inventory_quantity < 100){
        $('.inventory-counter .inventory-counter__bar .inventory-counter__bar-progress').css('width', value.inventory_quantity+'%');
      }else{
        $('.inventory-counter .inventory-counter__bar .inventory-counter__bar-progress').css('width', '100%');
      }
      // $('afterpay-placement').one('after', function() {
      //   $('afterpay-placement').after('<div class="custom_afterpay"></div>');
      // });
  
      // $('.inventory-counter').attr('data-stock-category', 'low');
      // $('.inventory-counter .inventory-counter__message').text(value.inventory_message);
      
      window.history.replaceState(null, null, newUrl); 
      $('.product__price-and-ratings .product__price [data-compare-price]').html(ThisProdCP)
      $('.product__price-and-ratings .product__price [data-price]').html(ThisProdNP)
      $('#cdk_product_act').attr('data-variant', thisMainVal);
      if (ThisProdAvail == 'true'){
        $('#cdk_product_act').find('.addToCartText').text('Add To Bag');
         $('#cdk_product_act').removeAttr('disabled');
      }else{
        $('#cdk_product_act').find('.addToCartText').text('Sold Out');
         $('#cdk_product_act').attr('disabled', '');
      }  
      $('#variant-selector').val(thisMainVal).change();
    })
    
    $(document).on('click' ,'#cdk_product_act',function(){
      // check sellin plan
      var selling_plan = ' ';
      var old_widget = $('.appstle_input_wrapper input');
      if(old_widget){
         var checked_plan = $('.appstle_input_wrapper input:checked').val();
         if(checked_plan != ""){   
         selling_plan = checked_plan;
       }
     }
      var new_widget =  $('.appstle_include_dropdown.appstle-active-option');
      if(new_widget){
          var checked_dropdown_plan = $('.appstle_include_dropdown.appstle-active-option .appstle_select option:selected').val();
         if(checked_dropdown_plan != ""){             
          selling_plan = checked_dropdown_plan;       
         }
      }
   console.log(selling_plan)
      
      // check selling plan
      const properties = {};
      const ioSelectors = document.querySelectorAll('#simple-bundles-io-options select[name*="properties"]');
      ioSelectors.forEach((ioSelector) => {
          if (!ioSelector) return;
          const ioSelectorName = ioSelector.name;
          if (!ioSelectorName) return;
          const optionKey = ioSelectorName.match(/\[(.*?)\]/)[1];
          const optionValue = ioSelector.value;
          if (!optionKey || !optionValue) return;
          properties[optionKey] = optionValue;
      });
      var currentThis = $(this);var updateItems = [];var variantId =  $(this).attr('data-variant');var quantity = $('.product__controls-group-quantity input').val();
      updateItems.push({
        "id": variantId, 
        "quantity": quantity, 
        "properties": properties, 
        "selling_plan": selling_plan
      });
      ajaxAddToCartProductPage(currentThis,updateItems);currentThis.addClass('loading');

    });
// Product page swatches options end

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if ($(window).width() <= 959 ) {
      if (scroll >= 50) {
        $("header.header").addClass("search_remove");
      } else {
          $("header.header").removeClass("search_remove");
      }
    }    
});

$('.quick-search__input').on('keyup', function() {
    var searchLength = $(this).val().length;
    console.log(searchLength);
    if ($(window).width() <= 959 ) {
      if (searchLength >= 1) {
        $("body,html").addClass("overflow__hidden");
      } else {
        $("body,html").removeClass("overflow__hidden");
      }
    }
});

$(document).on('click' ,'.quick-search__clear',function(event){ 
  event.preventDefault();
  if ($(window).width() <= 959 ) {
    $("body,html").removeClass("overflow__hidden");
  }
});


jQuery(document).ready(function(){
  var currentUrl = window.location.href;
  if (currentUrl.indexOf('?variant=') === -1) {
    jQuery("li.product-swatches-option:first-child").click();
  } else{
    var variantValue = currentUrl.split('?variant=')[1];
    var currentVariantValue = jQuery('.product_page-form__master-select').find(':selected').data('title');
    jQuery('li.product-swatches-option[data-value="'+currentVariantValue+'"]').click();
  }
})

// $(document).on("click", ".swathces__options__value", function(){
//      $(".product-thumbnails__item").hide();
//        var data_src = $(this).attr("data-value");
  
//        $(".product-thumbnails__item").each(function(){
//          var  thumbnails_src = $(this).attr("thumbnails-alt");
   
//      if (  thumbnails_src ==  data_src ) {
//         $(this).show();
         
//      }
           
//     });
//          });

class DynamicBadge {
  constructor(element) {
    this.element = element;
    this.updateVisibilityBasedOnVariant = this.updateVisibilityBasedOnVariant.bind(this);
    
    document.addEventListener('variant:change', this.updateVisibilityBasedOnVariant);
  }
  
  updateVisibilityBasedOnVariant(event) {
    if (!event) return;
    // Find the nearest container with variant titles defined
    const badgesContainer = this.element.closest('[data-allowed-variant-titles]');
    if (!badgesContainer) return;
    
    // Get the variant titles from the container's data attribute
    const variantTitles = badgesContainer.getAttribute('data-allowed-variant-titles');
    
    // Hide the badge by default
    this.element.style.display = 'none';
    const currentVariantTitle = event.detail.variantTitle;
    const validTitles = variantTitles.split(',').map(title => title.trim());
    
    // Show the badge if the current variant title matches any of the allowed titles
    if (currentVariantTitle && validTitles.includes(currentVariantTitle)) {
      this.element.style.display = '';
    }
  }
}

// Initialize dynamic badges
$(document).ready(function() {
  $('[is="dynamic-badge"]').each(function() {
    new DynamicBadge(this);
  });
});

